import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';
import { PlaybooksActionDefinitionInput } from 'src/app/models/componentInputs/playbookActionInput.interface';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';

@Component({
  selector: 'app-set-web-browsing-action',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatRadioModule, LabelsProviderPipe],
  templateUrl: './set-web-browsing-action.component.html',
  styleUrl: './set-web-browsing-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetWebBrowsingActionComponent {
  public fg = input.required<UntypedFormGroup>();
  public playbooksActionInput = input.required<PlaybooksActionDefinitionInput>();
  public triggerType = input.required<TriggerTypes>();
  public webBrowsingMode = model<boolean>(true);

  public onRadioButtonChange(value: boolean) {
    this.webBrowsingMode.set(value);
  }
}
